
import RoomView from './src/RoomView.vue' //智慧机房系统


let views = {

    RoomView,

};

export default views;